import { render, staticRenderFns } from "./item-details-modal.vue?vue&type=template&id=f921b1f2"
import script from "./item-details-modal.vue?vue&type=script&lang=js"
export * from "./item-details-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports